module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/manage/hospital/hospital.component.html
// module id = ./src/app/Pages/manage/hospital/hospital.component.html
// module chunks = main